export default __webpack_public_path__ + "static/media/bg_landing.c2ad20ac.jpg";